import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { GoalType } from '../../entities/goal-type';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class GoalTypeService {

  private static readonly goalTypeBaseUrl:string = `${Settings.apiUrl}/v1/GoalTypes`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public goalTypes:GoalType[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getGoalTypes():Promise<GoalType[]>{

    return this.cachedCallService.invokeSingleCall(
      () => {
        let oDataBuilder:ODataBuilder = new ODataBuilder(GoalTypeService.goalTypeBaseUrl);

        oDataBuilder
          .orderBy("Name");

        let goalTypeUrl:string = oDataBuilder.toString();

        return this.http.get(goalTypeUrl)
                .toPromise()
                .then(response => {

                  let formattedResponse:GoalType[] = response.json().value;

                  this.goalTypes = formattedResponse;

                  return formattedResponse;
                });
      }, "getGoalTypes"
    );
    
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/goal-type.service.ts